import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

function EmailVerified() {
    const navigate = useNavigate();

    const handleContinue = () => {
        // Navigate to beta subscription page
        navigate('/beta-subscription');
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 to-blue-50 dark:from-[#111920] dark:to-[#1B2731] px-4">
            <div className="max-w-md w-full bg-white dark:bg-[#222a32] rounded-2xl shadow-2xl p-8 text-center">
                {/* Success Icon */}
                <div className="flex justify-center mb-6">
                    <div className="bg-green-100 dark:bg-green-900/30 rounded-full p-4">
                        <CheckCircle className="w-16 h-16 text-green-600 dark:text-green-400" />
                    </div>
                </div>

                {/* Title */}
                <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                    Email Verified!
                </h1>

                {/* Message */}
                <p className="text-lg text-gray-600 dark:text-gray-300 mb-8">
                    Your email address has been successfully verified. You're all set to continue with your IzzyAI journey.
                </p>

                {/* Continue Button */}
                <button
                    onClick={handleContinue}
                    className="w-full bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA] text-white font-bold py-4 px-6 rounded-full hover:opacity-90 transition-all duration-300 hover:scale-105"
                >
                    Continue
                </button>

                {/* Additional Info */}
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-6">
                    Welcome to IzzyAI! 🎉
                </p>
            </div>
        </div>
    );
}

export default EmailVerified;












